import { useLingui } from '@lingui/react/macro';
import { Seo } from './seo';

/**
 * The head of every live 404. Apart from `not-found.tsx`, whose `Footer` pulls in the legal-content graph
 * its unit test cannot load; both 404s share one Lingui id.
 */
export function NotFoundSeo() {
	const { t } = useLingui();
	// No page here to point anywhere, and a crawler ignoring the 404 must still not index it.
	return <Seo title={t`Page not found - Worldcoo`} noindex />;
}
